import React from 'react';
import { ArrowRightIcon, DownloadIcon, MapPinIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { profile } from '../data/profile';
import { downloadResume } from '../utils/resumePdf';
import { AnimatedBackdrop } from './AnimatedBackdrop';
import { FramedPortrait } from './FramedPortrait';
export function Hero() {
  const reduceMotion = useReducedMotion();
  const enter = (delay: number) => reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.55,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  };
  return <section id="home" className="relative w-full overflow-hidden bg-navy" data-id="element-358" data-mp="sde1gppbdfu6">
      <AnimatedBackdrop data-id="element-359" data-mp="nboo33emcq2x" />
      <div className="absolute inset-x-0 top-0 h-px bg-metal/40" aria-hidden="true" data-id="element-360" data-mp="nekmstyajisf" />

      <div className="relative mx-auto grid max-w-shell grid-cols-1 items-center gap-16 px-6 pb-20 pt-16 sm:px-8 lg:grid-cols-[1.3fr_0.7fr] lg:gap-16 lg:pb-28 lg:pt-24" data-id="element-361" data-mp="3czfl7z4xc761">
        <div data-id="element-362" data-mp="3j9u2j3pddwnx">
          <motion.div className="flex items-center gap-3" {...enter(0)} data-id="element-363" data-mp="3j9283w7ie4z8">
            <span className="h-px w-10 bg-metal" aria-hidden="true" data-id="element-364" data-mp="3o6kfhi5voc54" />
            <span className="text-[11px] font-semibold uppercase tracking-label text-metal-light" data-id="element-365" data-mp="39al9qe68qo35">
              Executive Profile
            </span>
          </motion.div>

          <motion.h1 className="mt-7 font-serif text-[48px] font-semibold leading-[1.03] tracking-[-0.02em] text-white sm:text-6xl lg:text-[76px]" {...enter(0.06)} data-id="element-366" data-mp="3ebioshvyf20f">
            Kevin L.
            <br data-id="element-367" data-mp="2qk3kwkoj4cn2" />
            Brandenburg
          </motion.h1>

          <motion.p className="mt-7 max-w-xl border-l-2 border-metal pl-5 text-[15px] font-medium leading-relaxed text-white/85 sm:text-base" {...enter(0.12)} data-id="element-368" data-mp="2qlofgaaufvkx">
            {profile.title}
          </motion.p>

          <motion.p className="mt-8 max-w-2xl text-lg leading-[1.6] text-white/65 sm:text-xl lg:text-[22px]" {...enter(0.18)} data-id="element-369" data-mp="2lla70r5byjmd">
            {profile.subheadline}
          </motion.p>

          <motion.div className="mt-10 flex flex-wrap items-center gap-4" {...enter(0.24)} data-id="element-370" data-mp="naa1gt0e9mn1">
            <a href="#board-experience" className="group inline-flex items-center gap-2.5 bg-white px-7 py-4 text-sm font-semibold text-navy transition-colors duration-150 ease-premium hover:bg-metal-pale focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-371" data-mp="ibgnz0l3xvmv">
              View Board Experience
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-1" aria-hidden="true" data-id="element-372" data-mp="111ewfhsthqr1" />
            </a>
            <a href="#contact" className="inline-flex items-center gap-2.5 border border-white/25 px-7 py-4 text-sm font-semibold text-white transition-colors duration-150 ease-premium hover:border-metal hover:text-metal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-373" data-mp="3lui86njf0tjs">
              Get In Touch
            </a>
            <button type="button" onClick={downloadResume} className="inline-flex items-center gap-2 px-1 py-4 text-sm font-semibold text-white/70 underline decoration-metal decoration-1 underline-offset-4 transition-colors duration-150 ease-premium hover:text-metal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-374" data-mp="2b0fy9k5iavdx">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-375" data-mp="2txhc7uh1g5u0" />
              Download CV
            </button>
          </motion.div>

          <motion.p className="mt-8 inline-flex items-center gap-2 text-[13px] text-white/50" {...enter(0.3)} data-id="element-376" data-mp="zl10ie5h3zhr">
            <MapPinIcon className="h-3.5 w-3.5 text-metal-light" aria-hidden="true" data-id="element-377" data-mp="49jd24ununm4" />
            {profile.location}
          </motion.p>
        </div>

        <FramedPortrait data-id="element-378" data-mp="ea3h1f9ke681" />
      </div>
    </section>;
}